import {
  ActionTypes as types,
  forms,
  APIerrorMessages,
  paths,
} from 'constants';
import { Auth } from 'utils';
import { submitFormToIam, logError } from 'actions';
import { formatPhoneNumberForAPI } from 'utils/format';
import {
  resetAppErrors,
  updatePostAppError,
} from 'actions/setters/updateAppErrors';

const log = { component: 'changePhoneNumber' };

export default ({ values, isResendCode = false, push }) => dispatch => {
  const userGuid = Auth.getUserGuid();
  const phoneNumber = formatPhoneNumberForAPI(values.PhoneNumber);
  const userResource = `/users/${userGuid}/phonenumber/${phoneNumber}/issue-code`;

  const body = {
    userGuid,
    PhoneNumber: phoneNumber,
  };

  const onFetching = () => {
    if (isResendCode) {
      dispatch({
        type: types.RESEND_CODE,
      });
    }
    dispatch({
      type: types.VERIFY_PHONE,
      payload: phoneNumber,
    });
  };

  const onSuccess = () => {
    if (isResendCode) {
      dispatch({
        type: types.RESEND_CODE_SUCCESS,
      });
    }
    push(paths.VerifyPhone);
    dispatch(resetAppErrors());
  };

  const onError = (error = {}) => {
    if (isResendCode) {
      if (
        error !== APIerrorMessages.tooManyRequests ||
        error !== APIerrorMessages.wrongCode
      ) {
        dispatch(logError(types.RESEND_CODE_FAILURE, { ...log, error }));
      }
      dispatch({ type: types.RESEND_CODE_FAILURE });
    }

    if (
      error !== APIerrorMessages.tooManyRequests ||
      error !== APIerrorMessages.wrongCode
    ) {
      dispatch(logError(types.UPDATE_APP_STATUS_POST_ERROR, { ...log, error }));
    }
    dispatch(updatePostAppError(error));
  };

  return dispatch(
    submitFormToIam(forms.Phone, userResource, userGuid, body, {
      clearForm: true,
      onSuccess,
      onError,
      onFetching,
    }),
  );
};
